import { Component, OnDestroy, OnInit } from '@angular/core';
import { ServiceFeatures } from '../../../models/serviceFeatures';
import { INotification, INotificationsCount } from '../../../models/notifications';
import { SocketGroup, SocketService } from '../../../services/socket.service';
import { Subscription } from 'rxjs';
import { SessionService } from '../../../services/session.service';
import { ISnackBarAction, SnackBarService } from '../../../services/snack-bar.service';
import { DownloadService } from '../../../services/download.service';

import { SHARED_MODULES } from '../../../../shared.';
import { PhIconComponent } from '../../ph-icon/ph-icon.component';
import { PhIconWrapperComponent } from '../../ph-icon-wrapper/ph-icon-wrapper.component';
import { PhNotificationsPanelComponent } from '../ph-notifications-panel/ph-notifications-panel.component';
import { PhNotificationsDetailedPanelComponent } from '../ph-notifications-detailed-panel/ph-notifications-detailed-panel.component';
import { SidePanelComponent } from '../../side-panel/side-panel.component';

@Component({
	selector: 'ph-notifications',
	templateUrl: './ph-notifications.component.html',
	styleUrls: ['./ph-notifications.component.scss'],
	imports: [
		SHARED_MODULES,
		PhIconComponent,
		PhIconWrapperComponent,
		PhNotificationsPanelComponent,
		PhNotificationsDetailedPanelComponent,
		SidePanelComponent
	],
	standalone: true
})
export class PhNotificationsComponent implements OnInit, OnDestroy {

	private _subscriptions: Array<Subscription>;

	protected readonly hasAccess: boolean = true;

	public openedDetailsPanel: boolean = false;
	public openedPanel: boolean = false;
	public panelNotification: INotification;
	public count: INotificationsCount;

	constructor(
		private sessionService: SessionService,
		private socketService: SocketService,
		private snackBarService: SnackBarService,
		private downloadService: DownloadService
	) {
		this.hasAccess = this.sessionService.hasFeature(ServiceFeatures.Notifications);

		this.count = {
			total: 0,
			unread: 0,
			archived: 0
		}
	}

	ngOnInit(): void {
		if (!this.hasAccess) return;
		if (this.sessionService.isFramePage) return;

		this.socketService.addSubscription(SocketGroup.Notification);

		this._subscriptions = [
			this.socketService.notificationsCount.subscribe((count: INotificationsCount) => this.count = count),

			this.socketService.notification.subscribe((notification: INotification) => {
				const closeActions: Array<ISnackBarAction> = [];

				if (notification.action?.name === 'open_panel') {
					closeActions.push({
						action: 'COMMON.VIEW',
						callback: () => {
							this.openedDetailsPanel = true;
							this.panelNotification = notification;
						}
					});
				}
				if (notification.action?.name === 'open_link') {
					closeActions.push({
						action: 'GO',
						callback: () => {
							window.open(window.location.origin + notification.action.params.path, '_blank');
						}
					});
				}

				this.snackBarService.setSnackBarNotification({
					messageText: notification.title,
					closeActions: closeActions,
					durationSeconds: 5
				});
			}),

			this.downloadService.openNotificationSubject.subscribe((notification: INotification) => {
				this.openedDetailsPanel = true;
				this.panelNotification = notification;
			})
		];
	}

	public closePanel(): void {
		this.openedPanel = false;
		this.openedDetailsPanel = false;
		this.panelNotification = null;
	}

	ngOnDestroy(): void {
		if (!this.hasAccess) return;

		this.socketService.deleteSubscription(SocketGroup.Notification);
		this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
	}
}
